<ng-container [formGroup]="form">
  <div class="form-group form-group-{{type() | lowercase}}">
    @if (type() == "CHECKBOX") {
      <span class="form-checkbox-spacing"></span>
      <input type="checkbox" formControlName="{{name()}}" class="form-element" id="{{getId()}}">
      <label class="form-label-wrapper" for="{{getId()}}">{{ label() }}
        <ng-content></ng-content>
      </label>
    } @else {
      <div class="form-label-wrapper">
        <label class="form-label" for="{{getId()}}">{{ label() }}</label>
      </div>
      <div class="form-element-wrapper">
        @switch (type()) {
          @case ('INPUT') {
            <input type="text" formControlName="{{name()}}" placeholder="{{getPlaceholder()}}" class="form-element" id="{{getId()}}" (keyup)="onKeyup($event)" [readOnly]="isReadonly()">
          }
          @case ('INPUT_HIDDEN') {
            <input type="hidden" formControlName="{{name()}}" placeholder="{{getPlaceholder()}}" class="form-element" id="{{getId()}}">
          }
          @case ('PASSWORD') {
            <input type="password" autocomplete="{{autocomplete()}}" formControlName="{{name()}}" placeholder="{{getPlaceholder()}}" class="form-element" id="{{getId()}}">
          }
          @case ('TEXTAREA') {
            <textarea formControlName="{{name()}}" placeholder="{{getPlaceholder()}}" class="form-element" id="{{getId()}}"></textarea>
          }
          @case ('CHECKBOX') {
          }
          @case ('SELECT') {
            <select formControlName="{{name()}}" class="form-element" id="{{getId()}}" (change)="onChange($event)">
              @if (emptyOptionLabel()) {
                <option value="">{{ emptyOptionLabel() }}</option>
              }
              @if (selectValueOptions().size) {
                @for (valueOptionMap of selectValueOptions(); track valueOptionMap[0]) {
                  <option value="{{valueOptionMap[0]}}">{{ valueOptionMap[1] }}</option>
                }
              }
            </select>
          }
        }
      </div>
    }

    <ng-container *ngTemplateOutlet="errorMessages; context:{formElementVar:form.get(name())}">
    </ng-container>
    @if (helperText()) {
      <div class="helper-text">{{ helperText() }}</div>
    }
  </div>
</ng-container>

<ng-template let-formElement='formElementVar' #errorMessages>
  @if (!formElement?.valid && formElement?.touched) {
    <div>
      <div class="form-element-error">
        @if (form.controls[name()].errors?.['required']) {
          <div class="help-inline">
            Полето е задължително.
          </div>
        }
        @if (form.controls[name()].errors?.['email']) {
          <div class="help-inline">
            Полето не е валиден e-mail.
          </div>
        }
        @if (form.controls[name()].errors?.['bgIban']) {
          <div class="help-inline">
            Невалиден български IBAN.
          </div>
        }
        @if (form.controls[name()].errors?.['cyrillic']) {
          <div class="help-inline">
            Разрешени са само букви на кирилица, цифри и пунктуация.
          </div>
        }
        @if (form.controls[name()].errors?.['bgPin']) {
          <div class="help-inline">
            Невалидно ЕГН.
          </div>
        }
        @if (form.controls[name()].errors?.['bgIdCardNumber']) {
          <div class="help-inline">
            Невалиден номер на лична карта.
          </div>
        }
        @if (form.controls[name()].errors?.['numbersOnly']) {
          <div class="help-inline">
            Позволени са само цифри.
          </div>
        }
        @if (form.controls[name()].errors?.['numbersWithWhiteSpacesOnly']) {
          <div class="help-inline">
            Позволени са само цифри и интервали.
          </div>
        }
        @if (form.controls[name()].errors?.['confirmed']) {
          <div class="help-inline">
            Паролата и потвърждението не съвпадат.
          </div>
        }
        @if (form.controls[name()].errors?.['minlength']) {
          <div class="help-inline">
            Минимална дължина на въведения в полето текст трябва да е {{ form.controls[name()].errors?.['minlength'].requiredLength }}
          </div>
        }
        @if (form.controls[name()].errors?.['isUnique']) {
          <div class="help-inline">
            {{ form.controls[name()].errors?.['isUnique'].errorMessage }}
          </div>
        }
        @if (form.controls[name()].errors?.['bgMobilePhone']) {
          <div class="help-inline">
            Невалиден мобилен телефон.
          </div>
        }
      </div>
    </div>
  }
</ng-template>
